import { Box, createStyles, makeStyles, TextField } from '@material-ui/core'
import { colorPalette } from '../styleVariables'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Brand } from '../types/vmdata'
import { Experience } from '../types/expType'
import { getBrandLogoList } from '../libs/utils'

const useStyles = makeStyles(() =>
  createStyles({
    brandWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      marginBottom: '4rem',
    },
    image: {
      width: '7rem',
      height: '7rem',
      marginRight: '1rem',
      display: 'flex',
      position: 'relative',
      border: `2px solid ${colorPalette.grey}`,
      '& svg': {
        width: '100%',
        height: 'auto',
      },
      '& img': {
        width: '100%',
        height: 'auto',
        objectFit: 'contain',
      },
    },
  })
)

interface Props {
  brand?: Brand
  onBrandChanged: (value: { name: string; logoUrl: string }) => void
}

export const BrandLogo: React.FC<Props> = ({ brand, onBrandChanged }) => {
  const [showBrandLogo, setShowBrandLogo] = useState(false)
  const isDigitalWindow =
    useSelector((s) => s.vmData.expType) === Experience.DigitalWindow

  const [isWhiteBg, setIsWhiteBg] = useState(isDigitalWindow)

  const { name, logoUrl } = brand || {}
  const brandList = useSelector((state) => state.brands.items)

  const styles = useStyles()

  const onLoadBrandLogo = () => setShowBrandLogo(true)
  const onErrorBrandLogo = () => setShowBrandLogo(false)

  const handleChangeBrand = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newBrand = e.target.value

    const logo = getBrandLogoList(newBrand, brandList)
    let logoUrl = logo?.blackLogo || ''

    setIsWhiteBg(false)

    if (isDigitalWindow && logo?.whiteLogo) {
      logoUrl = logo?.whiteLogo
      setIsWhiteBg(true)
    }

    onBrandChanged({
      name: newBrand,
      logoUrl: logoUrl,
    })
  }

  return (
    <Box className={styles.brandWrapper}>
      <Box className={styles.image}>
        <img
          style={{
            display: showBrandLogo ? 'block' : 'none',
            filter: isWhiteBg
              ? 'drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.3))'
              : '',
          }}
          src={logoUrl}
          alt="brand logo"
          onLoad={onLoadBrandLogo}
          onError={onErrorBrandLogo}
        />
      </Box>
      <TextField
        style={{ flexGrow: 1 }}
        id="brandName"
        label="Brand"
        onInput={handleChangeBrand}
        value={name}
      />
    </Box>
  )
}
